import styles from "./dashboard-page.module.css";
import RecentShipments from "@/components/RecentShipments/RecentShipments";
import { useUserContext } from "@/contexts/UserContext";
import SellerAccountBanner from "../../../components/SellerAccountBanner/SellerAccountBanner";
import { FulfillmentType, PaymentStatus, UserRole } from "@boxem/core-api-schema";
import Select from "@/components/forms/Select/Select";
import { SalesBreakdown } from "../SalesBreakdown/SalesBreakdown";
import SalesSnapshotCards from "../SalesSnapshotCards/SalesSnapshotCards";
import { LocalStorageKeys } from "@/utils/localStorageUtils";
import Flex from "@/components/Flex/Flex";
import IconPlus from "@/components/icons/IconPlus";
import { useLocation } from "wouter";
import { useFbmListingContext } from "@/contexts/FbmListingContext";
import Tooltip from "@/components/Tooltip";
import Button from "@/components/forms/Button";

export default function Dashboard() {
  const { user, seller, setSeller } = useUserContext();
  const [location, navigate] = useLocation();
  const { resetFbmListingFlow } = useFbmListingContext();

  const fulfillmentPref = user.settings?.fulfillmentType ?? FulfillmentType.FBA;
  const handleCreateShipment = () => {
    if (fulfillmentPref ===  FulfillmentType.FBM) {
      navigate("/fbm/listings/create");
      resetFbmListingFlow(); // We will reset the flow if the user presses the "List FBA" option in the dropdown.
    } else {
      navigate("/fba/shipments/create");
    }
  };

  return (
    <div className={styles.container}>
      <Flex direction="row">
        <div className={styles.header}>
          <h3>{user ? `Hello ${user?.name}!` : ''}</h3>
          {user.paymentStatus === PaymentStatus.PAST_DUE
            ? <span className={styles.warning}>Your account is past due. Please make payment to continue using Boxem</span>
            : null}

            <Tooltip
              title={!user.sellerId && user.role !== UserRole.ASSISTANT ? "Connect your Amazon Seller Account first!" : ""}
            >
              <Button
                disabled={!user.sellerId && user.role !== UserRole.ASSISTANT}
                onClick={handleCreateShipment}
              >
                <IconPlus size={16} />
                Create Shipment
              </Button>
            </Tooltip>
        </div>
        {user && user.role !== UserRole.SELLER && <div className={styles.accountSelect}>
          <Select
            placeholder="Select Seller Account to Manage"
            options={user.sellers.map(s => s.name)}
            defaultOption={seller ? seller.name : user.sellers[0]?.name}
            optionRender={option => option}
            onChange={(option, index) => {
              const newSeller = user.sellers[index];
              setSeller(newSeller, true); //@TODO do we actually need to refetch data here?
            }}
          />
        </div>}
      </Flex>

      <SellerAccountBanner />

      <div className={styles.chartArea}>
        <SalesSnapshotCards />
        <SalesBreakdown />
      </div>
      <div className={styles.otherArea}>
        <RecentShipments />
      </div>
    </div>
  );
}
